module.exports = __webpack_public_path__ + "static/media/partner_zhongguoyouzheng.2c2ea7c1.png";